<div class="sidebar included">
	<app-sidebar-header [title]="'header.title.selectCountryAndLanguage' | ibeadmin: 'sync'">
	</app-sidebar-header>
	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<div class="header-fallback__market-content" *ngIf=!headerLoading>
			<div >
				<h3 class="title-h3">{{'header.text.selectCountry' | ibeadmin | async}}</h3>
				<div class="select-wrapper select-wrapper--language">
					<app-svg
						class="select-flag"
						svg="sprite.svg#{{ countriesList[selectedCountryIndex].image }}" aria-hidden="true" [alt]="countriesList[selectedCountryIndex].country + ' flag'"
					></app-svg>
					<label for="select-country-market" class="visuallyhidden">{{'header.text.selectCountry' | ibeadmin | async}}</label>
					<select id="select-country-market" class="select" (change)="INDRA_handleCountryClick($event)" [disabled]="INDRA_handleUserClick()">
						<option
							*ngFor="let country of countriesList; let index = index"
							value="{{ country.country }}"
							[selected]="index === selectedCountryIndex"
							>{{ country.country }}</option
						>
					</select>
				</div>
			</div>
			<div class="data-padding">
				<h3 class="title-h3">{{'header.text.selectLanguage' | ibeadmin | async}}</h3>
				<ul class="header-fallback__languages-list">
					<li (click)="INDRA_handleLanguageClick(index)"
						class="header-fallback__country-item" 
						*ngFor="let language of countriesList[selectedCountryIndex].language; let index = index">
						<a
							class="display--flex align-items-center"							
							href="javascript:;"
						>
							<span
								class="header-fallback__language-label"
								[ngClass]="{ 'is-active': selectedLanguageIndex === index }"
								>{{ language.label | ibeadmin:'sync' }}</span
							>
							<!-- <app-svg
						*ngIf="selectedLanguageIndex === index"
						class="header-fallback__language-selected"
						svg="icons.svg#general--check_big"
					></app-svg> -->
						</a>
					</li>
				</ul>
			</div>
		</div>
		<div class="grid align-center" *ngIf=!headerLoading>
			<button class="col-12 button top-gap" (click)="INDRA_handleSaveClick()">
				{{'header.text.save' | ibeadmin | async}}
			</button>
			<a class="col-12 link top-gap" (click)="INDRA_handleBackClick()" href="javascript:;" role="button">{{'header.text.back' | ibeadmin | async}}</a>
		</div>
		<app-loading *ngIf="headerLoading"></app-loading>
	</div>
</div>
